import { GET_CMS_CONTACTENOS } from "./types";
import CMSService from "../../services/cms.service";

export function getContactenos() {
  return function (dispatch) {
    try {
      return CMSService.reqContactenos().then((data) => {
        dispatch({
          type: GET_CMS_CONTACTENOS,
          payload: data,
        });
      });
    } catch (error) {
      // console.log("error", error);
    }
  };
}
